import React, { Component } from "react";

import DisplayModuleAvailable from "./../../../components/user/DisplayModuleAvailable";
import ButtonSeeCart from "./../../../components/user/ButtonSeeCart";
import logoLaddit from "./../../../img/svg/logo_laddition_white.svg";
import ovalLittleRed from "./../../../img/svg/oval_little_red.svg";
import ovalRed from "./../../../img/svg/oval_red.svg";
import { isDesktop, willOpenToday } from "../../../utils/utils";
import Fade from "@material-ui/core/Fade";
import { connect } from "react-redux";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayNxtTimeAvailable: false,
      screenDesktop: null,
      isRedirect: false,
    };
  }

  componentDidMount() {
    if (!this.state.screenDesktop) {
      window.scrollTo(0, document.body.scrollHeight);
    }
    if (this.props.openService) {
      this.setState({ displayNxtTimeAvailable: false });
    } else {
      this.setState({ displayNxtTimeAvailable: true });
    }
    this.setState({ screenDesktop: isDesktop(window) });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.openService !== nextProps.openService) {
      this.setState({ displayNxtTimeAvailable: !nextProps.openService });
    }
  }

  render() {
    const { displayNxtTimeAvailable, screenDesktop } = this.state;
    const {
      restaurantDescription,
      restaurantImages,
      restaurantSlogan,
      restaurantName,
      errorMessage,
      dataMessage,
      openServiceLater,
      nextHourOrderPickup,
    } = this.props;

    return (
      <Fade in={true} mountOnEnter unmountOnExit timeout={250}>
        <div id="home" className="content">
          <div className="container-title-action">
            <div className="title-home-page animated zoomIn">
              <h1>{restaurantName}</h1>
              <p className="slogan-home-page">{restaurantSlogan}</p>
              <p className="description-home-page">{restaurantDescription}</p>
              {displayNxtTimeAvailable ? (
                <DisplayModuleAvailable
                  textMessage={
                    openServiceLater
                      ? "tr-order-preorder"
                      : "tr-order-available"
                  }
                  screenDesktop={screenDesktop}
                  errorMessage={errorMessage}
                  dataMessage={
                    openServiceLater ? nextHourOrderPickup : dataMessage
                  }
                />
              ) : (
                ""
              )}
            </div>
            <ButtonSeeCart screenDesktop={screenDesktop} />
          </div>
          {screenDesktop ? (
            <React.Fragment>
              <div className="container-desktop-images">
                {restaurantImages.length ? (
                  <img
                    src={restaurantImages[0].image.value}
                    className="circle-img animated zoomIn display-desktop-none"
                  />
                ) : (
                  <div className="circle-blue animated zoomIn" />
                )}

                <img
                  src={ovalRed}
                  className="circle-red animated zoomIn display-desktop-none"
                  alt="red-img"
                />
              </div>
              <img
                src={logoLaddit}
                className="logo-laddit animated zoomIn"
                alt="logo-img"
              />
              <img
                src={ovalRed}
                className="circle-left-red animated zoomIn display-desktop-none"
                alt="left-red-img"
              />
              <img
                src={ovalLittleRed}
                className="circle-little-red animated zoomIn display-desktop-none"
                alt="little-red-img"
              />
            </React.Fragment>
          ) : null}
        </div>
      </Fade>
    );
  }
}

const mapStateToProps = (state) => {
  const { restaurant } = state;

  return {
    restaurantDescription: restaurant.infoRestaurant.description,
    errorMessage: restaurant.infoRestaurant.messageService,
    restaurantImages: restaurant.infoRestaurant.images,
    dataMessage: restaurant.infoRestaurant.dataMessage,
    openService: restaurant.infoRestaurant.serviceOpen,
    openServiceLater: restaurant.infoRestaurant.serviceOpenLater,
    nextHourOrderPickup: restaurant.infoRestaurant.nextHourOrderPickup,
    restaurantSlogan: restaurant.infoRestaurant.slogan,
    restaurantName: restaurant.infoRestaurant.name,
  };
};

export default connect(mapStateToProps)(Home);
